<div class="select-files-content">
    <core-files-selected-box
        [title]="'Your selected file' + (files.length > 1 ? 's':'')"
        [files]="files"
        (onFileActionClick)="onRemove($event)"
    ></core-files-selected-box>
    <h4 class="h4_subtitle">Select the file(s) to send from the list below</h4>
    <ng-container *ngIf="project != null else specificVersionSelection">
        <ng-container>
            <core-commons-files-list-checkbox 
                [url]="filesUrl"
                [counterPluralTitle]="'attachments'"
                [counterSingularTitle]="'attachment'"
                [selected]="files"
                (selectedChange)="onChange($event);"
                [disabled] = "false"
            ></core-commons-files-list-checkbox>
            <core-versions-related-selector
                [project]="project"
                [selected]="files"
                (selectedChange)="onChange($event);"
                [disabled]="false"
            ></core-versions-related-selector>

            <core-version-origin-version-files-list-checkbox
                [request]="project"
                [selected]="files"
                (selectedChange)="onChange($event);"
                [disabled]="false"
            ></core-version-origin-version-files-list-checkbox>
        </ng-container>
    </ng-container>
    <ng-template #specificVersionSelection>
        <div *ngIf="pageStatus != LOADING && selectionMode == SELECTION_MODE_VERSION else singleVersionLoading">
            <core-version-single-version-files-list-checkbox
                *ngIf="version != null else noVersionAvailable"
                [version]="version"
                [request]="requestHeader"
                [selected]="files"
                (selectedChange)="onChange($event);"
                [disabled]="false"
            ></core-version-single-version-files-list-checkbox>
            <ng-template #noVersionAvailable>
                <core-helpers-box-alert-message-icon 
                    [text]="'You do not have permission to send anything here.'"
                    [icon]="'warning'"
                ></core-helpers-box-alert-message-icon>
            </ng-template>
        </div>
        <ng-template #singleVersionLoading>
            <div class="loader" >
                <div class="dimmed">
                    <div class="dimmed_box"></div>
                </div>
            </div>
        </ng-template>
    </ng-template>
  </div>
